module.exports = __webpack_public_path__ + "img/modelshow05-5.2c55d90a.png";